import React from "react";
import { Col, DatePicker, Form, Input, InputNumber, Row, Select } from "antd";

const CURRENCY_OPTIONS = ["RUB", "USD", "EUR", "CNY", "MNT"].map((item) => ({
    label: item,
    value: item,
}));

/**
 * The Гүйлгээний Баримт field set, shared by manual entry and the edit modal so both forms stay
 * identical in layout and validation.
 *
 * The fields mirror the reference file's columns. "Нийт үнийн дүн" has no input of its own: the
 * server always derives it from Дүн x Ханш.
 */
function TransactionReceiptFormFields({ t }) {
    return (
        <Row gutter={[16, 0]}>
            <Col xs={24} md={12}>
                <Form.Item
                    label={t("col.name")}
                    name="name"
                    rules={[
                        { required: true, message: t("receipt.req.name") },
                        { max: 255, message: t("req.max255") },
                    ]}
                >
                    <Input placeholder={t("receipt.manual.ph.name")} allowClear />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={6}>
                <Form.Item
                    label={t("col.institution")}
                    name="institution"
                    rules={[{ max: 100, message: t("receipt.req.max100") }]}
                >
                    <Input placeholder={t("receipt.manual.ph.institution")} allowClear />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={6}>
                <Form.Item
                    label={t("col.currency")}
                    name="currency"
                    rules={[{ required: true, message: t("req.currency") }]}
                >
                    <Select
                        placeholder={t("col.currency")}
                        options={CURRENCY_OPTIONS}
                        showSearch
                        allowClear
                    />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8}>
                <Form.Item
                    label={t("col.amount")}
                    name="amount"
                    rules={[
                        { required: true, message: t("req.amount") },
                        { type: "number", min: 0.01, message: t("req.amountPositive") },
                    ]}
                >
                    <InputNumber
                        style={{ width: "100%" }}
                        placeholder="0.00"
                        precision={2}
                        min={0.01}
                        step={0.01}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        parser={(value) => `${value}`.replace(/,/g, "")}
                    />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8}>
                <Form.Item
                    label={t("col.rate")}
                    name="rate"
                    // Optional: a payment can be recorded before its rate is known. Left empty,
                    // the row is saved without a rate and without a total.
                    extra={t("receipt.rateOptional")}
                    rules={[
                        { type: "number", min: 0.0001, message: t("receipt.req.ratePositive") },
                    ]}
                >
                    <InputNumber
                        style={{ width: "100%" }}
                        placeholder={t("receipt.rateOptionalPh")}
                        precision={4}
                        min={0.0001}
                        step={0.0001}
                    />
                </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8}>
                <Form.Item label={t("col.executedDate")} name="executionDate">
                    <DatePicker
                        style={{ width: "100%" }}
                        format="YYYY-MM-DD"
                        placeholder={t("manual.ph.date")}
                    />
                </Form.Item>
            </Col>
        </Row>
    );
}

export default TransactionReceiptFormFields;
